
import Vue from 'vue'
import App from './App'
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import qs from 'qs';
import XLSX from 'xlsx'

import 'babel-polyfill';

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(ElementUI);
Vue.use(XLSX);
import axios from 'axios'
import VueAxios from 'vue-axios'
import './utils/http'

Vue.prototype.$axios = axios
Vue.use(VueAxios, axios)
Vue.prototype.$qs = qs
Vue.config.productionTip = false
// Vue.prototype.baseurl="https://pw.systekcn.com/pypw"
// Vue.prototype.baseurl="http://192.168.2.180:8333"
Vue.prototype.baseurl="http://39.103.160.89:8333"



  



new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js